import React from 'react';

import i18n from '@client/utils/i18n';
import { Chip } from '@mui/material';

interface LinkTypeChipProps {
    type: string;
    size?: 'small' | 'medium';
}

const chipSx = { height: 20, fontSize: '0.65rem' };

const mirrorSx = { ...chipSx, bgcolor: 'chip.mirror.bg', color: 'chip.mirror.text' };
const independentSx = { ...chipSx, bgcolor: 'chip.independent.bg', color: 'chip.independent.text' };

function LinkTypeChip({ type, size = 'small' }: LinkTypeChipProps) {
    const isMirror = type === 'mirror';
    return (
        <Chip size={size} label={i18n(isMirror ? 'linked_project_type_mirror' : 'linked_project_type_independent')} sx={isMirror ? mirrorSx : independentSx} />
    );
}

export default LinkTypeChip;
